import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import Router from "./router.js"
import * as serviceWorker from "./serviceWorker"
import { Provider } from "react-redux"
import { IntlProvider } from "react-intl"
import store from "./store.js"
import TagManager from "react-gtm-module"
import { getLocale, getMessages } from "./locale.js"

const locale = getLocale()
const TRACKING_ID = process.env.REACT_APP_GTM_ID
const TRACKING_ID_GA4 = process.env.REACT_APP_GA4_GTM_ID

if (String(TRACKING_ID) !== "DUMMY") {
  const tagManagerArgs = {
    gtmId: TRACKING_ID,
  }
  TagManager.initialize(tagManagerArgs)
}

if (String(TRACKING_ID_GA4) !== "DUMMY") {
  const tagManagerArgsGa4 = {
    gtmId: TRACKING_ID_GA4,
  }
  TagManager.initialize(tagManagerArgsGa4)
}

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale={locale} messages={getMessages(locale)}>
      <Router />
    </IntlProvider>
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
